// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notice-container {
  min-height: calc(100vh - 80px);
  padding: 20px;
  background-color: #f5f5f5;
}

.notice-page-title {
  margin: 0 0 30px 0;
  color: #333;
  font-size: 28px;
  text-align: center;
  border-bottom: 2px solid #007bff;
  padding-bottom: 15px;
}

.notice-layout {
  display: flex;
  gap: 20px;
  max-width: 1400px;
  margin: 0 auto;
  align-items: flex-start;
}

.notice-left-section {
  flex: 1 1;
  min-width: 0;
}

.notice-right-section {
  flex: 0 0 350px;
  position: sticky;
  top: 100px;
}

.notice-content {
  margin-bottom: 30px;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border-left: 4px solid #007bff;
}

.notice-content p {
  margin: 0;
  color: #666;
  line-height: 1.6;
}

.notice-download-section {
  padding: 25px;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 100px;
}

.notice-download-section h3 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 20px;
}

.notice-download-section p {
  margin: 0 0 20px 0;
  color: #666;
  font-size: 14px;
}

/* 양식 파일 목록 */
.form-file-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-file-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  background: #f8f9fa;
  font-size: 13px;
}

.form-file-item.latest {
  background: #e8f4fd;
  border-color: #b8daff;
}

.form-file-name {
  flex: 1 1;
  font-weight: 500;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.form-file-item:not(.latest) .form-file-name {
  color: #999;
}

.form-file-date {
  font-size: 12px;
  color: #888;
  white-space: nowrap;
}

.form-file-archived {
  font-size: 11px;
  color: #aaa;
  padding: 3px 8px;
  border: 1px solid #ddd;
  border-radius: 3px;
  white-space: nowrap;
}

.btn-download {
  padding: 5px 14px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  white-space: nowrap;
}

.btn-download:hover:not(:disabled) {
  background-color: #0056b3;
}

.btn-download:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.notices-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.notice-item {
  padding: 20px;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  background-color: white;
  transition: box-shadow 0.3s;
}

.notice-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.notice-item.important {
  background-color: #fff3cd;
  border-color: #ffc107;
}

.notice-item-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.notice-item-header h3 {
  margin: 0;
  color: #333;
  font-size: 18px;
}

.important-badge {
  padding: 4px 12px;
  background-color: #ffc107;
  color: #856404;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}

.notice-item-content {
  color: #333;
  line-height: 1.6;
  white-space: pre-wrap;
  margin-bottom: 12px;
}

.notice-item-footer {
  font-size: 12px;
  color: #666;
  padding-top: 12px;
  border-top: 1px solid #e9ecef;
}

/* 반응형 디자인 */
@media (max-width: 968px) {
  .notice-layout {
    flex-direction: column;
  }

  .notice-right-section {
    flex: 1 1;
    position: static;
    width: 100%;
  }

  .notice-download-section {
    position: static;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Notice.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,YAAY;AACZ;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".notice-container {\r\n  min-height: calc(100vh - 80px);\r\n  padding: 20px;\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n.notice-page-title {\r\n  margin: 0 0 30px 0;\r\n  color: #333;\r\n  font-size: 28px;\r\n  text-align: center;\r\n  border-bottom: 2px solid #007bff;\r\n  padding-bottom: 15px;\r\n}\r\n\r\n.notice-layout {\r\n  display: flex;\r\n  gap: 20px;\r\n  max-width: 1400px;\r\n  margin: 0 auto;\r\n  align-items: flex-start;\r\n}\r\n\r\n.notice-left-section {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.notice-right-section {\r\n  flex: 0 0 350px;\r\n  position: sticky;\r\n  top: 100px;\r\n}\r\n\r\n.notice-content {\r\n  margin-bottom: 30px;\r\n  padding: 20px;\r\n  background-color: #f8f9fa;\r\n  border-radius: 4px;\r\n  border-left: 4px solid #007bff;\r\n}\r\n\r\n.notice-content p {\r\n  margin: 0;\r\n  color: #666;\r\n  line-height: 1.6;\r\n}\r\n\r\n.notice-download-section {\r\n  padding: 25px;\r\n  background-color: #fff;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n  position: sticky;\r\n  top: 100px;\r\n}\r\n\r\n.notice-download-section h3 {\r\n  margin: 0 0 10px 0;\r\n  color: #333;\r\n  font-size: 20px;\r\n}\r\n\r\n.notice-download-section p {\r\n  margin: 0 0 20px 0;\r\n  color: #666;\r\n  font-size: 14px;\r\n}\r\n\r\n/* 양식 파일 목록 */\r\n.form-file-list {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.form-file-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 8px 12px;\r\n  border: 1px solid #e9ecef;\r\n  border-radius: 6px;\r\n  background: #f8f9fa;\r\n  font-size: 13px;\r\n}\r\n\r\n.form-file-item.latest {\r\n  background: #e8f4fd;\r\n  border-color: #b8daff;\r\n}\r\n\r\n.form-file-name {\r\n  flex: 1;\r\n  font-weight: 500;\r\n  color: #333;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.form-file-item:not(.latest) .form-file-name {\r\n  color: #999;\r\n}\r\n\r\n.form-file-date {\r\n  font-size: 12px;\r\n  color: #888;\r\n  white-space: nowrap;\r\n}\r\n\r\n.form-file-archived {\r\n  font-size: 11px;\r\n  color: #aaa;\r\n  padding: 3px 8px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 3px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.btn-download {\r\n  padding: 5px 14px;\r\n  background-color: #007bff;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n  white-space: nowrap;\r\n}\r\n\r\n.btn-download:hover:not(:disabled) {\r\n  background-color: #0056b3;\r\n}\r\n\r\n.btn-download:disabled {\r\n  background-color: #6c757d;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.notices-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.notice-item {\r\n  padding: 20px;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 8px;\r\n  background-color: white;\r\n  transition: box-shadow 0.3s;\r\n}\r\n\r\n.notice-item:hover {\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.notice-item.important {\r\n  background-color: #fff3cd;\r\n  border-color: #ffc107;\r\n}\r\n\r\n.notice-item-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.notice-item-header h3 {\r\n  margin: 0;\r\n  color: #333;\r\n  font-size: 18px;\r\n}\r\n\r\n.important-badge {\r\n  padding: 4px 12px;\r\n  background-color: #ffc107;\r\n  color: #856404;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n}\r\n\r\n.notice-item-content {\r\n  color: #333;\r\n  line-height: 1.6;\r\n  white-space: pre-wrap;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.notice-item-footer {\r\n  font-size: 12px;\r\n  color: #666;\r\n  padding-top: 12px;\r\n  border-top: 1px solid #e9ecef;\r\n}\r\n\r\n/* 반응형 디자인 */\r\n@media (max-width: 968px) {\r\n  .notice-layout {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .notice-right-section {\r\n    flex: 1;\r\n    position: static;\r\n    width: 100%;\r\n  }\r\n\r\n  .notice-download-section {\r\n    position: static;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
